import React, { useContext, useEffect, useState } from 'react'
import LoginContext from "../../Context/Logincontext"
import Nav1 from '../../Component/Nav/Nav1'
import { NavLink } from 'react-router-dom'
import "../../styles/AddProduct.css"
import '../../styles/AddClient.css'
import '../../styles/AddCompositeProduct.css'
import Swal from 'sweetalert2'
import { ImExit } from 'react-icons/im'
import CloseButton from '../../Component/CloseButton'
import LogoComponent from '../../Component/LogoComponent'
import { urlApiServer } from '../../Config/Config'

let splitImg = []

const EditCompositeProduct = (props) => {
    const urlputCompositeproduct = urlApiServer + "editCompositeproduct";
    const urlgetConfig = urlApiServer + "getConfig";
    const urlgetInventorys = urlApiServer + "getinventory"
    const urlgetCompositeproductById = urlApiServer + "getCompositeproductById";

    const [name, setName] = useState('')
    const [rawMaterialGetTable, setRawMaterialGetTable] = useState([])
    const [utility, setUtility] = useState('');
    const [inventoryFields, setInventoryFields] = useState([
        { material: null, quantity: [], extent: [], pricePerMeasure: [] } // Estado inicial con un conjunto de campos
    ]);
    const [materialIds, setMaterialIds] = useState([{ id: 0, missing: 0 }]);
    const [laborPrice, setLaboralPrice] = useState(null);
    const [unit, setUnit] = useState(null);
    const [vat, setVat] = useState(null);
    const [totalPrice, setTotalPrice] = useState('');
    const { infoUser, setInfoUser } = useContext(LoginContext)
    const [oldConfig, setOldConfig] = useState("")
    const [logo, setLogo] = useState("")

    async function off() {

        Swal.fire({
            icon: 'warning',
            title: '¿Estás seguro de que quieres volver atrás?',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                props.edit()
            }
        })
    }

    useEffect(() => {
        async function fetchData() {
            try {
                // First fetch
                const InicioHeaders = new Headers();
                InicioHeaders.append("Content-Type", "application/json")
                const requesoption = {
                    method: 'GET',
                    headers: InicioHeaders,
                    redirect: 'follow'
                }
                const configResponse = await fetch(urlgetConfig, requesoption);
                const configData = await configResponse.json();
                setOldConfig(configData);

                // Second fetch
                const InicioHeaders2 = new Headers();
                InicioHeaders2.append("Content-Type", "application/json");
                InicioHeaders2.append("company", infoUser.company);
                const requesoption2 = {
                    method: 'GET',
                    headers: InicioHeaders2,
                    redirect: 'follow'
                };
                const inventoryResponse = await fetch(urlgetInventorys, requesoption2);
                const inventoryData = await inventoryResponse.json();
                setRawMaterialGetTable(inventoryData.reverse());
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }

        fetchData();
    }, [urlgetInventorys, infoUser.company]);

    useEffect(() => {
        (async function () {
            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json")
            InicioHeaders.append("id", props.id);
            InicioHeaders.append("company", infoUser.company);

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            }

            await fetch(urlgetCompositeproductById, requesoption)
                .then(response => response.json())
                .then(quotesResponse => {
                    console.log("quotesResponse: ", quotesResponse[0]);

                    const productData = quotesResponse[0];
                    if (productData) {
                        setName(productData.product);
                        setLaboralPrice(productData.laborprice)
                        setUnit(productData.unit)
                        setVat(productData.vat)
                        setUtility(productData.utility)
                        // Mapear los materiales al formato de inventoryFields
                        const mappedMaterials = productData.materials.map(material => ({
                            material: material.material,
                            quantity: material.quantity,
                            extent: material.extent,
                            pricePerMeasure: material.pricePerMeasure
                        }));

                        setInventoryFields(mappedMaterials);

                        // Calcular el precio total usando la función existente
                        calculateTotalPrice(mappedMaterials);

                        // Establecer los IDs de los materiales
                        const ids = productData.materials.map(material => ({
                            id: material.material.id,
                            missing: 0
                        }));
                        setMaterialIds(ids);
                    }
                })
        })()
    }, [props.id, infoUser.company])

    useEffect(() => {
        if (oldConfig) {
            const foundConfig = oldConfig.find(obj => obj.empresa === infoUser.company);
            if (foundConfig) {
                const { logo } = foundConfig;
                setLogo(logo);
            }
        }
    }, [oldConfig, infoUser])

    if (logo) {
        splitImg = logo.split("|")
    }

    async function handleName(e) {
        const name = e.target.value.replace(/[^A-Z a-z0-9.]/g, "");
        setName(name)
    }

    async function handleLaborPrice(e) {
        const laborPrice = e.target.value.replace(/[^0-9-._]/g, '');
        setLaboralPrice(laborPrice);
        calculateTotalPrice(inventoryFields);
    }

    async function handleUnit(e) {
        const unit = e.target.value;
        setUnit(unit)
    }

    async function handleVat(e) {
        const vat = e.target.value;
        setVat(vat);
        calculateTotalPrice(inventoryFields);
    }

    async function handleUtility(e) {
        const utility = e.target.value.replace(/[^0-9.]/g, '');
        setUtility(utility);
        calculateTotalPrice(inventoryFields);
    }

    async function uploadInventory() {
        const data = JSON.stringify({
            empresa: infoUser.company,
            id: props.id,
            name: name,
            laborprice: laborPrice,
            unit: unit,
            vat: vat,
            inventoryFields: inventoryFields,
            totalPrice: totalPrice,
            utility: utility
        })
        const registerHeaders = new Headers();
        registerHeaders.append("Content-Type", "application/json")

        const requesoption = {
            method: 'PUT',
            headers: registerHeaders,
            body: data,
            redirect: 'follow'
        }

        await fetch(urlputCompositeproduct, requesoption).then(response => response.json())
            .then(dataResponse => {
                if (200 === dataResponse.status) {
                    return Swal.fire({
                        icon: 'success',
                        title: '¡Hecho!',
                        text: dataResponse.msj,
                        allowOutsideClick: false,
                        confirmButtonText: 'Aceptar',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.href = './Producto_Compuesto';
                        }
                    })
                }
                if (101 === dataResponse.status) {
                    return Swal.fire({
                        icon: 'error',
                        title: '¡Error!',
                        text: dataResponse.msj,
                        confirmButtonText: 'Aceptar',
                    })
                }
            })
    }

    const handleAddMoreFields = () => {
        setInventoryFields([...inventoryFields, { material: null, quantity: [], extent: [], pricePerMeasure: [] }]);
    };

    const handleSelectInventory = (index, selectedMaterialName) => {
        const updatedFields = [...inventoryFields];

        if (selectedMaterialName === "") {
            updatedFields[index].material = null;
            updatedFields[index].quantity = ""; // Vaciar cantidad al deseleccionar
            updatedFields[index].extent = "";
        } else {
            const material = rawMaterialGetTable.find(m => m.nameofmaterial === selectedMaterialName);
            if (material) {
                updatedFields[index].material = material;
                updatedFields[index].quantity = ""; // No autocompletar, dejar vacío para entrada manual
                updatedFields[index].extent = material.defaultMeasure || "";
                updatedFields[index].pricePerMeasure = material.pricePerMeasure || "";
            }
        }

        setInventoryFields(updatedFields);
        setMaterialIds(updatedFields.map(field => field.material?.id).filter(id => id !== undefined));
        calculateTotalPrice(updatedFields);
    };

    const calculateTotalPrice = (fields) => {
        // 1. Calcular costo total de materiales
        let materialsTotal = fields.reduce((sum, field) => {
            if (!field.material || !field.pricePerMeasure) return sum;

            const price = parseFloat(field.pricePerMeasure) || 0;

            // Calcular para otros tipos: precio * medida * cantidad
            const measure = parseFloat(field.extent) || 1;
            return sum + (price * measure);

        }, 0);

        // 2. Obtener valores base
        const labor = parseFloat(laborPrice) || 0;
        const vatPercentage = parseFloat(vat) || 0;
        const utilityValue = 1 + (parseFloat(utility) || 0) / 100; // Convertir a multiplicador (ej: 10% -> 1.10)

        // 3. Calcular subtotal (mano de obra + materiales)
        const subtotal = labor + materialsTotal;

        // 4. Calcular total con cantidad de productos y IVA
        const totalWithQuantity = subtotal;
        const totalWithVat = totalWithQuantity * (1 + vatPercentage / 100);
        const totalWithUtility = totalWithVat * utilityValue;

        setTotalPrice(totalWithUtility.toFixed(2));
    };

    useEffect(() => {
        calculateTotalPrice(inventoryFields);
    }, [laborPrice, vat, utility, inventoryFields]);


    const handleRemoveFields = (index) => {
        const updatedFields = [...inventoryFields];
        updatedFields.splice(index, 1);
        setInventoryFields(updatedFields);
    };

    const handleInventoryExtent = (index, value) => {
        const updatedFields = [...inventoryFields];
        updatedFields[index].extent = value.replace(/[^0-9-._]/g, ''); // Permite decimales
        setInventoryFields(updatedFields);
        calculateTotalPrice(updatedFields); // Recalcula el precio total
    };

    const handleInventoryPricePerMeasure = (index, value) => {
        const updatedFields = [...inventoryFields];
        updatedFields[index].pricePerMeasure = value.replace(/[^0-9-_]/g, '');
        setInventoryFields(updatedFields);
    };

    const handleTotalPrice = (index, value) => {
        const totalPrice = e.target.value;
        setTotalPrice(totalPrice)
    };

    return (
        <>
            {(infoUser.login === true) ? (
                (infoUser.role === 'SuperUsuario') ? (window.location.href = './Crear_Empresa') : (
                    <>
                        <div className="containerHeardANDTable">
                            <div className="HeardANDFilter">
                                <LogoComponent />
                                <div className='containerButtonAdd'>
                                    <div className="navigationContainer">
                                        <div className="pageTitle">EDITAR PRODUCTO COMPUESTO</div>
                                    </div>
                                </div>
                                <div className='closeIntContainer'>
                                    <CloseButton />
                                </div>
                            </div>
                        </div>
                        <div id='overallContainer' className='overallContainer'>
                            <Nav1 />
                            <div className='drawerFormAddCuotes'>
                                <form className='ContainerClient'>
                                    <div className='containerInfoAdd'>
                                        <div className='infoOneEdit'>
                                            <p className='personalInformationEdit'>EDITAR PRODUCTO COMPUESTO</p>
                                            <p className='personalInformationEdit'>Producto</p>
                                            <div className='containerNameClient'>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        value={name}
                                                        name="Name"
                                                        id="Name"
                                                        onChange={handleName}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Nombre del producto <em className='Obligatory'>*</em> </label>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="number"
                                                        value={laborPrice}
                                                        name="laborPrice"
                                                        id="laborPrice"
                                                        onChange={handleLaborPrice}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Precio de mano de obra <em className='Obligatory'>*</em> </label>
                                                </div>
                                            </div>
                                            <div className='containerNameClient'>
                                                <div className="inputClientContainer">
                                                    <select
                                                        type="text"
                                                        value={unit}
                                                        name="unit"
                                                        id="unit"
                                                        onChange={handleUnit}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    >
                                                        <option value="">Unidad: </option>
                                                        <option value="U">U (Unidad)</option>
                                                        <option value="M">M (Metros)</option>
                                                        <option value="M2">M2 (Metros Cuadrados)</option>
                                                        <option value="C">C (Centimetros)</option>
                                                        <option value="P">P (Pulgadas)</option>
                                                        <option value="K">K (Kilogramos)</option>
                                                        <option value="G">G (Gramos)</option>
                                                        <option value="L">L (Libras)</option>
                                                        <option value="LT">LT (Litros)</option>
                                                        <option value="R">R (Radianes)</option>
                                                        <option value="R">S (Segundos)</option>
                                                        <option value="H">H (Horas)</option>
                                                        <option value="Dia/s">Dias</option>
                                                        <option value="Mes/es">Meses</option>
                                                        <option value="Año/s">Años</option>
                                                    </select>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <select
                                                        type="text"
                                                        value={vat}
                                                        name="vat"
                                                        id="vat"
                                                        onChange={handleVat}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    >
                                                        <option value="">Iva: </option>
                                                        <option value="0">0%</option>
                                                        <option value="5">5%</option>
                                                        <option value="16">16%</option>
                                                        <option value="19">19%</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <p className='personalInformationEdit'>Material</p>
                                            {inventoryFields.map((field, index) => (
                                                <div className='inventaryAddCompositeProductContainer'>
                                                    <div className='containerNameClient'>
                                                        <div className="inputClientContainer">
                                                            <select
                                                                type="text"
                                                                value={field.material ? field.material.nameofmaterial : ''}
                                                                name="Material"
                                                                id="Material"
                                                                onChange={(e) => handleSelectInventory(index, e.target.value)}
                                                                className="inputCLient"
                                                                placeholder=" "
                                                            >
                                                                <option value="">Seleccione un material</option>
                                                                {rawMaterialGetTable
                                                                    .sort((a, b) => a.nameofmaterial.localeCompare(b.nameofmaterial))
                                                                    .map((nameOfMaterial, idx) => (
                                                                        <option key={idx} value={nameOfMaterial.nameofmaterial}>
                                                                            {nameOfMaterial.nameofmaterial}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="inputClientContainer">
                                                            <input
                                                                type="text"
                                                                value={field.extent}
                                                                name="extent"
                                                                id="extent"
                                                                placeholder=" "
                                                                className="inputCLient"
                                                                onChange={(e) => handleInventoryExtent(index, e.target.value)}  // Agrega esto
                                                            />
                                                            <label htmlFor="name">
                                                                {field.material?.typeOfMeasure || "medida"} <em className='Obligatory'>*</em>
                                                            </label>
                                                            {/* <label htmlFor="name">Medida <em className='Obligatory'>*</em></label> */}
                                                        </div>
                                                    </div>
                                                    <div className='containerNameClient'>
                                                        <div className="inputClientContainer">
                                                            <input
                                                                type="number"
                                                                value={field.pricePerMeasure}
                                                                name="pricePerMeasure"
                                                                id="pricePerMeasure"
                                                                placeholder=" "
                                                                className="inputCLient"
                                                                onChange={(e) => handleInventoryPricePerMeasure(index, e.target.value)}
                                                                readOnly
                                                            // onBlur={() => handleInventoryQuantityBlur(index)}
                                                            />
                                                            <label htmlFor="name">
                                                                Precio por {field.material?.typeOfMeasure || "medida"} <em className='Obligatory'>*</em>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='buttonContainerAddQuotes2'>
                                                        {index === inventoryFields.length - 1 && (
                                                            <NavLink onClick={handleAddMoreFields} className='Textregister'>
                                                                <button className="button neon_Effect"><p>Mas</p></button>
                                                            </NavLink>
                                                        )}
                                                        {inventoryFields.length > 1 && (
                                                            <NavLink onClick={() => handleRemoveFields(index)} className="Textregister">
                                                                <button className="button neon_Effect"><p>Menos</p></button>
                                                            </NavLink>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                            <div className='containerNameClient'>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="number"
                                                        value={utility}
                                                        name="utility"
                                                        id="utility"
                                                        placeholder=" "
                                                        className="inputCLient"
                                                        onChange={handleUtility}
                                                    />
                                                    <label htmlFor="utility">Utilidad (%)</label>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="number"
                                                        value={totalPrice}
                                                        name="totalPrice"
                                                        id="totalPrice"
                                                        placeholder=" "
                                                        className="inputCLient"
                                                        readOnly
                                                    />
                                                    <label htmlFor="name">
                                                        Precio total del producto <em className='Obligatory'>*</em>
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="buttonContainerAddClient">
                                                <NavLink className='Textregister' onClick={off}><button className="button neon_Effect"><p>Atras</p></button></NavLink>
                                                <NavLink onClick={uploadInventory} className='Textregister'><button className="button neon_Effect"><p>Actualizar</p></button></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </>
                )
            ) : (window.location.href = './Iniciar_Sesión')}
        </>
    )
}

export default EditCompositeProduct